import { connect } from 'react-redux';

import Produits from '../components/Produits';
function mapStateToProps(state) {
  return {
    langues: state.demandeCredit.getIn(['langues', 'value']),
  };
}

export default connect(mapStateToProps)(Produits);
